<template>
  <v-dialog scrollable :value="showDialog" max-width="500" @input="close">
    <v-card>
      <v-toolbar color="teal" dark>
        <v-toolbar-title>Likes</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-list subheader v-if="likedUsers.length > 0">
          <v-list-item v-for="likedUser in likedUsers" :key="likedUser.id">
            <v-list-item-avatar>
              <view-image
                defaultImage="user"
                :image="likedUser.user.profile_image"
              ></view-image>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>{{ likedUser.user.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <div
          v-else
          style="height: 200px"
          class="d-flex justify-center align-center"
        >
          No Users Liked
        </div>
        <v-divider></v-divider>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close()" class="ma-2 white--text blue-color" text
          >Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    postID: { type: Number, default: null },
    type: { type: String, default: "details" },
  },
  data() {
    return {
      showDialog: false,
      likedUsers: [],
    };
  },
  watch: {
    postID(val) {
      if (val != null) {
        this.showDialog = true;
        this.openlikedUsers();
      }
    },
  },
  methods: {
    openlikedUsers() {
      this.showLoader("Loading");
      this.$http.get(`posts/${this.postID}/likes`).then((response) => {
        if (response.status == 200 && response.data.status == true) {
          const data = response.data.data;
          this.likedUsers = data.likes;
          this.hideLoader();
        }
      });
    },
    close() {
      this.showDialog = false;
      this.$emit("close");
    },
  },
};
</script>

<style></style>
